export const commerceQueryKeys = {
	boosts: {
		pricing: (clubId: string) => ["boosts", clubId, "pricing"] as const,
		status: (clubId: string) => ["boosts", clubId, "status"] as const,
	},
	badges: {
		pricing: (clubId: string) => ["badges", clubId, "pricing"] as const,
		status: (clubId: string) => ["badges", clubId, "status"] as const,
		verificationQueue: (status?: string) =>
			["badges", "verification-queue", status ?? "pending_review"] as const,
	},
} as const;
